import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text16 } from '../../../ui/Text16';
import {    
    FooterMenuTitle,
    JuridicialItem   
} from '../footer.style';

export const JuridicialAddress: React.FC<{}> = () => {
    const { t } = useTranslation();
    return(
        <JuridicialItem>
            <FooterMenuTitle>{t('juridical_address')}</FooterMenuTitle>
            <Text16>
                SIMPALS S.R.L.MD-2059, mun. Chișinău, str. Calea Orheiului, 28/1Cod fiscal: 1004600001907 
            </Text16>
        </JuridicialItem>
    )
}

